<template>
  <el-dialog
      title="作者编辑"
      :visible.sync="dialogVisible"
      @open="getWriter"
      @close="handleClose"
      >
    <el-form ref="form" :model="form" label-width="100px">
      <input type="hidden" v-model="form.id" />
      <el-form-item label="作者姓名">
        <el-input v-model="form.writer_name"></el-input>
      </el-form-item>
      <el-form-item label="作者简介">
        <el-input type="textarea" :rows="4"  v-model="form.writer_info" placeholder=""></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="handleClose">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>

</template>

<script>
import axios from "axios";

export default {
  name: "getWriterView",
  data(){
    return{
      dialogVisible:this.show,
      form: {
        id: "",
        writer_name: "",
        writer_info: ""
      },
      mode: 'default', // or 'simple'
    }
  },
  watch:{
    show(val){
      this.dialogVisible = val
      // this.resetData();
    }
  },
  props:{
    show: {
      type: Boolean,
      default: false
    },
    id:{
      type: [String,Number],
      default: '0'
    }
  },
  // created() {
  //   this.getCategory();
  // },
  methods:{
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    getWriter() {
      let id = this.$props.id;
      if(id > 0){
        axios.get('/api/Writer/getWriter.html?id='+id).then((res)=>{
          if(res.data.code == 200){
            this.form = res.data.data;
          }
        });
      }
    },
    resetData(){
      this.form = this.$options.data().form;
    },
    handleClose() {
      this.$emit("dialogShowChange",false);
      this.resetData()
    },
    onSubmit() {
      axios({
        method:'post',
        url:'/api/Writer/setWriter.html',
        data:this.form
      }).then((res)=>{
        if(res.data.code != 200) {
          alert(res.data.msg);
        }
        else{
          alert(res.data.msg);
          this.handleClose();
        }
      })
    },
  }
}
</script>
<style scoped>

</style>